import { Provider } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ShivaGNVertPublicConfiguration } from 'src/swagger-gen/gnvert-public/shiva-gn-vert-public-configuration';
import { ShivaGNVertSecuredConfiguration } from 'src/swagger-gen/gnvert-secured/shiva-gn-vert-secured-configuration';
import { ShivaWebPublicConfiguration } from 'src/swagger-gen/web-public/shiva-web-public-configuration';
import { ShivaWebSecuredConfiguration } from 'src/swagger-gen/web-secured/shiva-web-secured-configuration';

export const provideSwaggerCore = (): Provider[] => [
  {
    provide: ShivaGNVertPublicConfiguration,
    useFactory: () => {
      const config = new ShivaGNVertPublicConfiguration();
      config.rootUrl = environment.publicApiUrl;
      return config;
    },
  },
  {
    provide: ShivaGNVertSecuredConfiguration,
    useFactory: () => {
      const config = new ShivaGNVertSecuredConfiguration();
      config.rootUrl = environment.apiUrl;
      return config;
    },
  },
  {
    provide: ShivaWebPublicConfiguration,
    useFactory: () => {
      const config = new ShivaWebPublicConfiguration();
      config.rootUrl = environment.publicApiUrl;
      return config;
    },
  },
  {
    provide: ShivaWebSecuredConfiguration,
    useFactory: () => {
      const config = new ShivaWebSecuredConfiguration();
      config.rootUrl = environment.apiUrl;
      return config;
    },
  },
];
